__turbopack_context__.v({
  "badge": "Badge-module___uO2Xq__badge",
  "icon": "Badge-module___uO2Xq__icon",
  "text": "Badge-module___uO2Xq__text",
});
